import { render } from "./AddToCartContainer.vue?vue&type=template&id=125727a1"
import script from "./AddToCartContainer.vue?vue&type=script&lang=js"
export * from "./AddToCartContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__